'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ServiceAnalysisGridController = function ServiceAnalysisGridController($log, $scope, $rootScope, $window, ssiUrlService, dataRetrieverService, configurationService, reoptimizationService, dataRetrieverConstantsService, calculateEffectiveValueService, renormalizeEffectiveValue, liveDataService, currentStateCriteriaService, featureToggleService, overridesUtilsService, momentService, directForecastingConfigurationService, selectedMarketHelperService, userPreferencesService) {
  $scope.serviceAnalysisContextMenuItems = [];
  function setupContextMenu() {
    $scope.serviceAnalysisContextMenuItems = [];
    var market = selectedMarketHelperService.getSelectedMarket(_.get($scope, 'filterData.markets'), _.get($scope, 'demandManagementData.main'));
    if (featureToggleService.isDisabled('SEGMENT_CLASS_CONTROL')) {
      $scope.serviceAnalysisContextMenuItems.push({
        caption: 'Inventory Analyzer',
        event: 'context-menu:service-analysis-ssi-analyzer'
      });
    }
    if (directForecastingConfigurationService.isDirectForecastEnabled(market)) {
      $scope.serviceAnalysisContextMenuItems.push({
        caption: 'Demand Transparency',
        event: 'context-menu:service-demand-transparency'
      });
    }
  }
  $scope.cogOptions = require('../config/cogOptions').service;
  $scope.cogOptionsBookingMatrix = require('../config/cogOptions').serviceBookingMatrix;
  $scope.gridId = 'service-demand-analysis';
  $scope.bookingMatrixMode = 'bookingsIncremental';
  $scope.enableBookingMatrix = false;
  $scope.showBookingMatrix = false;
  $scope.bookingMatrixInitialized = false;
  var dataRetriever = dataRetrieverService.getDataRetriever($scope.screen, $scope.mode);
  var dataRetrieverBookingMatrix = dataRetrieverService.getDataRetriever($scope.screen, dataRetrieverConstantsService.BOOKING_MATRIX_MODE);
  dataRetriever.isQueryingMoreDomains(!$scope.isDemandManagement);
  $scope.updateBookingMatrixMode = function () {
    dataRetrieverBookingMatrix.updateAdditionalParameters({
      bookingMatrixMode: $scope.bookingMatrixMode
    });
  };
  function retrieveData() {
    dataRetriever.retrieveComponentData('service-demand-analysis-data-handler');
  }
  $scope.onSearchChangeEvent = function () {
    if (!currentStateCriteriaService.isPostDeparture()) {
      retrieveData();
    }
  };
  function logSaveError(msg) {
    $log.error('ServiceAnalysisGridController: onSaveClick - ' + msg);
    toastr.error(msg);
  }
  $scope.customSaveValidation = function (overrides) {
    var rowsValid = true;
    if (!renormalizeEffectiveValue.validateUserShare(overrides)) {
      rowsValid = false;
      logSaveError('Sum of User share cannot be greater than 100%');
    }
    if (!overridesUtilsService.validateStartRtpOverrides(overrides)) {
      rowsValid = false;
      logSaveError('Demand adjustment cannot be empty if startRtp is set');
    }
    return rowsValid;
  };
  function findAffectedServices(gridData, rowData) {
    return _.filter(gridData, function (item, index) {
      if (_.isMatch(item, {
        serviceId: rowData.serviceId
      })) {
        item.originalRowId = index;
        return true;
      }
    });
  }
  function setManualCtrlIndicator(gridData, rowData, colName, ctrlIndicatorValue) {
    var affectedRows = findAffectedServices(gridData, rowData);
    return _.chain(affectedRows).map(function (row) {
      return _.findIndex(gridData, {
        originalRowId: row.originalRowId
      });
    }).filter(function (value) {
      return value !== -1;
    }).forEach(function (rowId) {
      gridData[rowId][colName] = ctrlIndicatorValue;
    }).value();
  }
  $scope.onCellEditHandler = function (gridData, rowId, colName) {
    var isDemandDistributionIncremental = configurationService.isDemandDistributionIncremental();
    var rowData = gridData[rowId];
    var affectedRowIds = [rowId];
    var affectedColumns = [];
    if (!isDemandDistributionIncremental) {
      var effectiveField = calculateEffectiveValueService.getField(rowData, colName, $scope.gridId);
      if (effectiveField) {
        affectedColumns = [effectiveField.fieldName];
        var affectedRows = renormalizeEffectiveValue.findAffectedRows(gridData, rowData, colName);
        if (affectedRows.length > 0) {
          //this function will change affectedRows array
          affectedColumns = _.union(affectedColumns, renormalizeEffectiveValue.renormalize(affectedRows, colName, true));
          affectedRowIds = _.chain(affectedRows).map(function (row) {
            return _.findIndex(gridData, {
              originalRowId: row.originalRowId
            });
          }).filter(function (value) {
            return value !== -1;
          }).value();
        } else {
          rowData[effectiveField.fieldName] = effectiveField.value;
        }
      }
    }
    if (colName === 'isManuallyControlled') {
      var ctrlIndicatorValue = gridData[rowId][colName];
      affectedRowIds = setManualCtrlIndicator(gridData, rowData, colName, ctrlIndicatorValue);
    }
    return {
      ids: affectedRowIds,
      fieldNames: affectedColumns
    };
  };
  $scope.reloadBookingMatrix = function () {
    if ($scope.showBookingMatrix) {
      $scope.$broadcast('grid:loadData:service-demand-analysis-booking-matrix');
      $scope.bookingMatrixInitialized = true;
    }
  };
  $scope.toggleBookingMatrix = function () {
    $scope.showBookingMatrix = !$scope.showBookingMatrix;
    if (!$scope.bookingMatrixInitialized) {
      $scope.reloadBookingMatrix();
    }
  };
  $scope.$on('service-analysis:oneDaySelected', function (event, oneDaySelected) {
    $scope.enableBookingMatrix = oneDaySelected;
    $scope.bookingMatrixInitialized = false;
    $scope.reloadBookingMatrix();
  });
  $scope.$on('search-criteria:searchChangeEvent', $scope.onSearchChangeEvent);
  $scope.$on('clearChangedValue', retrieveData);
  $scope.$on('cog:grid-service-booking-matrix', function (event, cogValue) {
    $scope.bookingMatrixMode = cogValue.val[0];
    $scope.updateBookingMatrixMode();
    $scope.$broadcast('grid:loadData:service-demand-analysis-booking-matrix');
  });
  $scope.$on('context-menu:service-analysis-ssi-analyzer', function (event, selectedRows) {
    var ssiUrl = ssiUrlService.buildSsiUrl(selectedRows[0], configurationService.getSsiUrl());
    $window.open(ssiUrl);
  });
  $scope.$on('context-menu:service-demand-transparency', function (event, selectedRows) {
    var selectedRow = selectedRows[0];
    if (!selectedRow) {
      return;
    }
    $rootScope.$broadcast('demand-transparency:swap', true, {
      timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
      searchCriteria: {
        carrier: selectedRow.hostCarrier,
        market: selectedRow.market,
        classGroup: selectedRow.classGroup,
        spos: selectedRow.posName,
        season: selectedRow.season,
        dowGroup: selectedRow.dowGroup,
        mappedProfileLevel: selectedRow.mappedProfileLevel,
        regularProfileLevel: selectedRow.regularProfileLevel,
        lastProcessedDateMoment: selectedRow.lastProcessedDateMoment,
        departureDate: selectedRow.departureDateMoment,
        serviceBusinessId: selectedRow.serviceBusinessId,
        className: selectedRow.className
      }
    });
  });
  $scope.$on('reoptimizeMarketServiceGrid', function (event, selectedRows) {
    reoptimizationService.reoptimizeFromMarketScreen(selectedRows, $scope.scenarioName);
  });
  $scope.$on('service-analysis:filterUpdated', function () {
    liveDataService.unsubscribeGrid($scope.gridId);
  });
  $scope.updateBookingMatrixMode();
  $scope.$on('market-analysis-toggle:toggleMode', function (event, mode) {
    if (mode === 'service') {
      setupContextMenu();
    }
  });
  $scope.screenState = {
    isServiceGridExpanded: userPreferencesService.getUserSettingComponent('isServiceGridExpanded') || false
  };
  $scope.$on('gridExpand:service-demand-analysis', function () {
    $scope.screenState.isServiceGridExpanded = !$scope.screenState.isServiceGridExpanded;
  });
  setupContextMenu();
};
ServiceAnalysisGridController.$inject = ['$log', '$scope', '$rootScope', '$window', 'SsiUrlService', 'DataRetrieverService', 'ConfigurationService', 'ReoptimizationService', 'DataRetrieverConstantsService', 'CalculateEffectiveValueService', 'RenormalizeEffectiveValueService', 'LiveDataService', 'CurrentStateCriteriaService', 'FeatureToggleService', 'OverridesUtilsService', 'MomentService', 'DirectForecastingConfigurationService', 'SelectedMarketHelperService', 'UserPreferencesService'];
module.exports = ServiceAnalysisGridController;